/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_code_messages_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Neznámá chyba při použití kódu slevy`
};

const da_discount_code_messages_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Ukendt fejl ved anvendelse af rabatkoden`
};

const de_discount_code_messages_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Unbekannter Fehler beim Anwenden des Rabattcodes`
};

const en_discount_code_messages_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Unknown error while applying the discount code`
};

const es_discount_code_messages_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Error desconocido al aplicar el código promocional`
};

const fr_discount_code_messages_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Erreur inconnue lors de l'application du code promo`
};

const hu_discount_code_messages_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Ismeretlen hiba a promóciós kód alkalmazásakor`
};

const it_discount_code_messages_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Errore sconosciuto durante l'applicazione del codice sconto`
};

const nl_discount_code_messages_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Onbekende fout bij het toepassen van de kortingscode`
};

const pl_discount_code_messages_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Nieznany błąd podczas stosowania kodu rabatowego`
};

const pt_discount_code_messages_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Erro desconhecido ao aplicar o código promocional`
};

const sv_discount_code_messages_unknown = /** @type {(inputs: {}) => string} */ () => {
	return `Okänt fel vid tillämpning av rabattkod`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_code_messages_unknown = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_code_messages_unknown(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_code_messages_unknown", locale)
	if (locale === "cs") return cs_discount_code_messages_unknown(inputs)
	if (locale === "da") return da_discount_code_messages_unknown(inputs)
	if (locale === "de") return de_discount_code_messages_unknown(inputs)
	if (locale === "en") return en_discount_code_messages_unknown(inputs)
	if (locale === "es") return es_discount_code_messages_unknown(inputs)
	if (locale === "fr") return fr_discount_code_messages_unknown(inputs)
	if (locale === "hu") return hu_discount_code_messages_unknown(inputs)
	if (locale === "it") return it_discount_code_messages_unknown(inputs)
	if (locale === "nl") return nl_discount_code_messages_unknown(inputs)
	if (locale === "pl") return pl_discount_code_messages_unknown(inputs)
	if (locale === "pt") return pt_discount_code_messages_unknown(inputs)
	return sv_discount_code_messages_unknown(inputs)
};
export { discount_code_messages_unknown as "discount_code_messages.unknown" }